import { NAME } from './constants';

export const PAID = `${NAME}/PAID`;
export const AUTHORIZED = `${NAME}/AUTHORIZED`;
export const AUTHORIZED_CALLBACK = `${NAME}/AUTHORIZED_CALLBACK`;
